<div class="page">
  <div class="title">{{ palletId }}</div>
  <qr-code [value]="palletId" errorCorrectionLevel="M" size="500" darkColor="#495057"></qr-code>
</div>
